<template>
  <div :class="`${mobile ? 'mx-auto' : 'pc_or_tablet'}`" class="mx-auto px-4 fade-in">
    <span @click="$router.push(`/shop/collections`)">
      <div class="d-flex align-center mb-4 black--text"><v-icon color="black">mdi-chevron-left</v-icon>戻る</div>
    </span>
    <div :class="`${mobile ? 'thumbnail' : ''}`" class="mb-8"><img :src="collection.images[0].image_url" width="100%" /></div>
    <div class="mb-3 text-h5 font-weight-black">{{ collection.name }}</div>
    <div style="white-space: pre-line" class="mb-4 note">{{ collection.note }}</div>
    <div class="mb-8 flowers">
      <span class="mb-4" v-for="flower in collection.available_flowers" :key="flower.id"><Flower :flower="flower" :onClick="onClick"/></span>
    </div>
    <div class="term">コレクション掲載期間: {{ start }}〜{{ end }}</div>
    <div class="another">
      <div class="text-h6 font-weight-bold black--text mb-3 mt-2 pt-2">他のコレクション</div>
      <div v-for="arr in listArr" :key="arr" class="d-flex collection mb-2" @click="toDetail(arr)">
        <img :src="list[arr].images[0] ? list[arr].images[0].image_url : ''" width="100px" class="mr-2" style="border-radius: 5px;"/>
        <div class="center">
          <v-chip small :color="list[arr].is_open ? 'black' : ''" :class="list[arr].is_open ? 'white--text' : ''">{{ list[arr].is_open ? '開催中' : 'coming soon' }}</v-chip>
          <p class="mt-2 font-weight-bold">{{ list[arr].name }}</p>
        </div>
        <div width="30px" v-if="list[arr].is_open">
          <v-icon large color="black">mdi-chevron-right</v-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Flower from "@/components/shop/collections/Flower.vue";
import { formatDate } from "@/plugins/i18n";

export default {
  components: {
    Flower
  },

  data() {
    return {
      collection: {}
    };
  },

  computed: {
    mobile() {
      return this.$vuetify.breakpoint.xs;
    },
    start() {
      return formatDate(this.collection.start_date, "yyyy年mm月dd日");
    },
    end() {
      return formatDate(this.collection.end_date, "yyyy年mm月dd日");
    },
    list() {
      return this.$store.state.Collection.list;
    },
    listArr() {
      return this.$store.state.Collection.listArr.filter(arr => Number(arr) !== Number(this.$route.params.collectionId));
    }
  },
  methods: {
    onClick(flowerId) {
      this.$router.push(`/shop/products/${flowerId}`);
    },
    toDetail(collectionId) {
      const collection = this.list[collectionId];
      if (collection.is_open) {
        this.$router.push(`/shop/collections/${collectionId}`);
        this.collection = this.list[collectionId];
      }
    }
  },

  async created() {
    const { status, result } = await this.$http("get", `/collections/${this.$route.params.collectionId}`);
    if (status === 200) { this.collection = result.collection; }

    this.$store.dispatch("Collection/getCollections");
  }
};
</script>

<style lang="scss" scoped>
.pc_or_tablet {
  width: 500px;
}

.flowers {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: auto;
  padding: 0;
  color: #191D38;
}

.thumbnail{
  width: 100vw;
  margin-left: -15px;
}

.note {
  font-size: 14px;
}

.term {
  color: #707070;
  font-size: 12px;
}

.another {
  border-top: 1px solid #F1F1F1;

  .collection {
    width: 100%;
  }

  .note {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding-right: 22px;
  }

  .center {
    width: 100%;
  }
}
</style>
